<app-nav-panel [navItems]="items" class="stepper"></app-nav-panel>
<router-outlet></router-outlet>
